import React from "react";
import Image from "next/image";
import dynamic from "next/dynamic";
import BlogSkeletonCard from "@/components/blog/BlogSkeletonCard";

const DynamicMainPosts = dynamic(() => import("./BlogMainPosts"), {
  ssr: false,
  loading: () => <BlogSkeletonCard />,
});

export const BlogMain = () => {
  return (
    <div className="labtop:gap-12 flex flex-col gap-10 bg-white pb-16 text-black">
      <MainBanner />
      <DynamicMainPosts />
    </div>
  );
};

const MainBanner = () => (
  <section className="relative -mx-4 overflow-hidden px-6 py-16 text-center laptop:mx-0 laptop:rounded-2xl">
    {/* Desktop Image */}
    <Image
      src="/images/blog/blog-main-banner.jpg"
      alt="Desktop Banner"
      fill
      className="hidden object-cover laptop:block"
    />

    {/* Mobile Image */}
    <Image
      src="/images/blog/blog-main-banner-mobile.jpg"
      alt="Mobile Banner"
      fill
      className="block object-cover laptop:hidden"
    />

    <div className="relative z-10">
      <h1 className="mb-4 text-6xl font-400">Blog</h1>
      <p className="text-sm laptop:text-lg">
        Check out the latest bHaptics news, product announcements,
        <br />
        compatible games and more contents
      </p>
    </div>
  </section>
);
